import { jsx as _jsx } from "react/jsx-runtime";
function SvgComponent() {
    return (_jsx("svg", { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", viewBox: "0 0 24 24", children: _jsx("path", { d: "M18 6L6 18M6 6l12 12" }) }));
}
export default SvgComponent;
